
<template>
  <div>
    <!-- <mheader></mheader> -->
    <div v-show="tableData.length > 0" style="width: 1300px; margin: 0 auto" id="v-content"
      :style="{ minHeight: Height + 'px' }">
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img src="../../static/images/kucun.png" style="width: 1.5rem; height: 1.5rem" class="mb-lg-1" alt="" />
          <span class="p-1" style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            ">
            禁网销售
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
            <span>
              <span class="ml-3"> 总金额: </span>
              <span style="color: red; font-size: 15px">
                ¥{{ totalPurchMoney }}
              </span>
            </span>
          </span>
          <span class="float-right span_close" style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            " @click="$router.go(-1)">
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span>
        </p>
        <div class="row mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input type="text" class="form-control font heit" v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div class="row">
                      <div class="col-lg-4 p-0 text-center font">批号:</div>
                      <div class="col-lg-8 p-0">
                        <input type="text" class="form-control font" v-model="searchForm.ph" style="height: 1.5rem"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input type="text" class="form-control font" v-model="searchForm.cdmc" style="height: 1.5rem"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div class="row">
                      <div class="col-lg-4 p-0 text-center font">规格:</div>
                      <div class="col-lg-8 p-0">
                        <input type="text" class="form-control font" v-model="searchForm.gg" style="height: 1.5rem"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <el-select v-model="SearchType" placeholder="请选择" size="mini" @change="Search">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
            </div>
          </div>
        </div>

        <table v-if="searchData.length > 0" class="table table-striped table-hover" ref="print">
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>药品名称</th>
              <th>产地名称</th>
              <th>库区</th>
              <th>规格</th>
              <th>批号</th>
              <th>单位</th>
              <th>单价</th>
              <th>零/整</th>
              <th>包装</th>
              <th>数量</th>
              <th>有效期至</th>
              <th>入账日期</th>
              <th>打折情况</th>
              <th>返利情况</th>
              <th>是否拆零</th>
              <th style="color: green">中包装</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in searchData" :key="index" class="text-center">
              <td class="jz_middle" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td class="jz_middle" @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td class="jz_middle">{{ item.storeNo }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.batchNum }}</td>
              <td class="jz_middle">{{ item.unit }}</td>
              <td class="jz_middle">{{ item.price }}</td>
              <td class="jz_middle">{{ item.isRetail | lin }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle">{{ item.storeNum }}</td>
              <td class="jz_middle">{{ item.dueDate }}</td>
              <td class="jz_middle">{{ item.inAccountDate | formatUTC }}</td>
              <td class="jz_middle">{{ item.disCountRate | rate }}</td>
              <td class="jz_middle">{{ item.isPromotion }}</td>
              <td class="jz_middle">{{ item.saleMPack | pack }}</td>
              <td class="jz_middle" style="color: green">{{ item.mPack }}</td>
              <td class="jz_middle text-muted" style="width: 200px">
                <button class="bg-primary button_zi" v-if="item.wwSj == 0" @click="stopSell(item, index)">
                  禁止网上销售
                </button>
                <button v-else-if="item.wwSj == 1" class="bg-primary button_zi mt-2" @click="stopSell(item, index)">
                  取消禁止网上销售
                </button>
              </td>
              <!-- <td
                v-show="item.storeNo != 'aa'"
                class="jz_middle text-muted"
                style="width: 200px"
              ></td> -->
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-hover" ref="print" v-else>
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>药品名称</th>
              <th>产地名称</th>
              <th>库区</th>
              <th>规格</th>
              <th>批号</th>
              <th>单位</th>
              <th>单价</th>
              <th>零/整</th>
              <th>包装</th>
              <th>数量</th>
              <th>有效期至</th>
              <th>入账日期</th>
              <th>打折情况</th>
              <th>返利情况</th>
              <th>是否拆零</th>
              <th style="color: green">中包装</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index" class="text-center">
              <td class="jz_middle" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td class="jz_middle" @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td class="jz_middle">{{ item.storeNo }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.batchNum }}</td>
              <td class="jz_middle">{{ item.unit }}</td>
              <td class="jz_middle">{{ item.price }}</td>
              <td class="jz_middle">{{ item.isRetail | lin }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle">{{ item.storeNum }}</td>
              <td class="jz_middle">{{ item.dueDate }}</td>
              <td class="jz_middle">{{ item.inAccountDate | formatUTC }}</td>
              <td class="jz_middle">{{ item.disCountRate | rate }}</td>
              <td class="jz_middle">{{ item.isPromotion }}</td>
              <td class="jz_middle">{{ item.saleMPack | pack }}</td>
              <td class="jz_middle" style="color: green">{{ item.mPack }}</td>
              <td class="jz_middle text-muted" style="width: 200px">
                <button class="bg-primary button_zi" v-if="item.wwSj == 0" @click="stopSell(item, index)">
                  禁止网上销售
                </button>
                <button v-else-if="item.wwSj == 1" class="bg-primary button_zi mt-2" @click="stopSell(item, index)">
                  取消禁止网上销售
                </button>
              </td>
              <!-- <td
                v-show="item.storeNo != 'aa'"
                class="jz_middle text-muted"
                style="width: 200px"
              ></td> -->
            </tr>
          </tbody>
        </table>

        <div>
          <v-pagination :total="total" :current-page="current" @pagechange="pagechange"></v-pagination>
        </div>

        <p class="text-center">
          <img src="../../static/images/tuding.png" style="width: 1.5rem; height: 1.5rem" alt="" />
        </p>
      </div>
      <!-- container -->
    </div>

    <div v-show="Pcount === 0" style="width: 1300px; margin: 0 auto" id="v-content" :style="{ minHeight: Height + 'px' }">
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img src="../../static/images/kucun.png" style="width: 1.5rem; height: 1.5rem" class="mb-lg-1" alt="" />
          <span class="p-1" style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            ">
            库存查询
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
            <span>
              <span class="ml-3"> 总金额: </span>
              <span style="color: red; font-size: 15px">
                ¥{{ totalPurchMoney }}
              </span>
            </span>
          </span>
          <span class="float-right span_close" style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            " @click="$router.go(-1)">
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600">库存详细(凡是没有上传图片的药品，均不显示！双击药品名称或者生产厂家可以快速检索！)</span>
        </p>
        <div class="row mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input type="text" class="form-control font heit" v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-4 p-0 text-center font">批号:</div>
                      <div class="col-lg-8 p-0">
                        <input type="text" class="form-control font" v-model="searchForm.ph" style="height: 1.5rem"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input type="text" class="form-control font" v-model="searchForm.cdmc" style="height: 1.5rem"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div class="row">
                      <div class="col-lg-4 p-0 text-center font">规格:</div>
                      <div class="col-lg-8 p-0">
                        <input type="text" class="form-control font" v-model="searchForm.gg" style="height: 1.5rem"
                          @keydown.enter="searchEnterFun" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div style="margin-left: 10px">
                      <el-select v-model="SearchType" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
            </div>
          </div>
        </div>
        <img src="../../static/images/wushuju.jpg" style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt="" />
        <p class="text-center">
          <img src="../../static/images/tuding.png" style="width: 1.5rem; height: 1.5rem" alt="" />
        </p>
      </div>
      <!-- container -->
    </div>
    <div>
      <transition name="fade">
        <loading v-show="isLoading"> </loading>
      </transition>
    </div>
    <!-- 是否 -->
    <div class="modal fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="
            width: 500px;
            height: 200px;
            position: relative;
            top: 300px;
            left: 200px;
            margin-bottom: 50px;
          ">
          <div class="modal-head head-style"></div>
          <div class="modal-body" style="font-size: 20px">
            <div v-if="showModal">
              <div style="width: 100%; text-align: center; color: red" class="m-0">
                此操作只可对零库药品进行操作，你确定将
                <span>{{ currentDrugName }}</span>进行此操作吗？
              </div>
            </div>
            <div v-else>
              <div style="width: 100%; text-align: center; color: red" class="m-0">
                此操作只可对零库药品进行操作，你确定取消对
                <span>{{ currentDrugName }}</span>进行此操作吗？
              </div>
            </div>

            <div style="text-align: right" class="mt-3">
              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="reallyRemovable()">
                <span aria-hidden="true"></span>确认
              </button>
              <button type="button" class="btn btn-info ml-3" data-dismiss="modal">
                <span aria-hidden="true"></span>取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 是否 -->
    <div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="
            width: 500px;
            height: 200px;
            position: relative;
            top: 300px;
            left: 200px;
            margin-bottom: 50px;
          ">
          <div class="modal-head head-style">
            <p class="text-center" style="font-size: 20px; line-height: 50px">
              <span>
                可填数量为0-
                <span>{{ mPack }}</span>
                之间的整数
              </span>
            </p>
          </div>
          <div class="modal-body">
            <div>
              <div style="width: 100%; text-align: center; color: red" class="m-0">
                <p style="font-size: 20px" class="mt-3">
                  <span> 请输入最小销售数量: </span>
                  <input type="text" class="text-center" v-model="currentType" />
                </p>
              </div>
            </div>

            <div style="text-align: right" class="mt-4">
              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="QueDing()">
                <span aria-hidden="true"></span>确认
              </button>
              <button type="button" class="btn btn-info ml-3" data-dismiss="modal">
                <span aria-hidden="true"></span>取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="禁网设置" :visible.sync="dialogDiscount" :width="'800px'" :close-on-click-modal="false" center>
      <div>
        <el-form :model="formDiscount" label-width="100px">
          <!-- <el-form-item label="手机号：" required>
            <el-select v-model="form.tel" placeholder="请选择手机号码">
              <el-option v-for="(item, index) of phones" :key="index" :label="item.tel" :value="item.tel"></el-option>
            </el-select>
            <el-button style="margin-left: 20px" type="primary" :disabled="disabled" size="medium" @click="getCode">{{
              btnText }}</el-button>
          </el-form-item> -->
          <el-form-item label="二级密码：" required>
            <el-input v-model="form.yzm" placeholder="请输入二级密码" style="width: 53%" maxlength="6"></el-input>
            <el-link href="/secondpass">忘记密码?</el-link>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogDiscount = false">取 消</el-button>
        <el-button type="primary" :disabled="telDisabled" :loading="telDisabled" @click="submitSell">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
export default {
  name: "SaleQuery",
  data() {
    return {
      options: [
        {
          value: 1,
          label: "默认排序",
        },
        {
          value: 3,
          label: "日期排序",
        },
      ],
      Height: 0,
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
      }, //搜索内容
      form: {
        "tel": "",
        "storeID": "",
        "yzm": "",
        index: -1,
        wwSj: -1
      },
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      SearchType: 1, // 查询类型
      excelData: [],
      totalPurchMoney: "",
      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数
      currentDrugName: "",
      showModal: true,
      currentType: "",
      currentStoreID: "",
      mPack: "",
      index: "",
      dialogDiscount: false,
      telDisabled: false,
      DiscountList: [],
      formDiscount: {
        //设置折扣的参数
        promotionID: 0,
        storeID: 0,
        disCount: 0,
        phone: "",
        yzm: "",
      },
      initForm: {}, //初始化折扣的参数
      phones: [], //手机号列表
      disabled: false, //判断发送验证码是否禁用
      totalCount: 0, //倒计时120S
      success: false,
      isShow: true,
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {
    btnText() {
      return this.totalCount != 0
        ? `${this.totalCount}秒再次获取`
        : "获取验证码";
    },
  },
  filters: {
    //过滤器时间转换
    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    lin: function (data) {
      if (data == 1) {
        return "零";
      } else {
        return "整";
      }
    },
    pack: function (status) {
      if (status == 1) {
        return "是";
      } else {
        return "否";
      }
    },
    rate: function (rate) {
      if (rate == 1) {
        return "不打折";
      } else {
        return "打" + rate * 10 + "折";
      }
    },
  },

  methods: {
    QueDing() {
      const that = this;
      let reg = /[\.]/;
      if (
        Number(that.currentType) > 0 &&
        Number(that.currentType) <= that.mPack &&
        reg.test(that.currentType) == false
      ) {
        $("#myModal2").modal();
      } else {
        alert("请输入正确的数值");
      }
    },
    removable(drugName, storeID, mPack, index) {
      this.currentDrugName = drugName;
      this.showModal = true;
      this.currentStoreID = storeID;
      this.index = index;
      this.mPack = mPack;
      this.currentType = "";
      $("#myModal1").modal();
    },
    noRemovable(drugName, storeID, index) {
      this.currentDrugName = drugName;
      this.showModal = false;
      this.currentType = 0;
      this.currentStoreID = storeID;
      this.index = index;
      $("#myModal2").modal();
    },

    reallyRemovable: async function () {
      const that = this;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "Storeaakczbzxs",
        obj: JSON.stringify({
          storeID: that.currentStoreID,
          Type: that.currentType,
        }),
      });
      // console.log(res)
      if (res.isok) {
        if (res.data.isSucceed) {
          if (that.searchData.length > 0) {
            that.searchData[that.index].saleMPack = that.currentType;
          } else {
            that.tableData[that.index].saleMPack = that.currentType;
          }
          that.$message.success("操作成功!");
        } else {
          that.$message.fail("操作失败!");
        }
      }
    },

    stopSell(item, index) {
      this.form.wwSj = item.wwSj;
      this.form.index = index;
      this.form.storeID = item.storeID;
      this.isPhones();
      this.dialogDiscount = true;
    },

    submitSell() {
      const that = this;
      // if (!this.form.tel) {
      //   return this.$message.warning('请选择手机号');
      // }

      if (!this.form.yzm) {
        return this.$message.warning('请填写二级密码')
      }
      if (this.form.yzm.length!=6) {
        return this.$message.warning('您输入的二级密码位数有误！')
      }
      this.telDisabled = true;
      if (this.form.wwSj == 0) {
        this.$http
          .post("Dls/StopOnlineNew", {
            "tel": this.form.tel,
            "storeID": this.form.storeID,
            "yzm": this.form.yzm
          })
          .then((res) => {
            this.telDisabled = false;
            this.dialogDiscount = false;
            if (res.data.isOk) {
              if (res.data.data.statusCode == 200) {
                that.$message.success("操作成功!");
                this.$set(this.tableData[this.form.index], 'wwSj', 1);
                this.$set(this.searchData[this.form.index], 'wwSj', 1);
              } else {
                this.$message.error(res.data.data.message)
              }
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(err => {
            this.dialogDiscount = false;
            this.telDisabled = false;
          })
      } else if (this.form.wwSj == 1) {
        this.$http
          .post("Dls/CancleStopOnlineNew", {
            "tel": this.form.tel,
            "storeID": this.form.storeID,
            "yzm": this.form.yzm
          })
          .then((res) => {
            this.telDisabled = false;
            this.dialogDiscount = false;
            if (res.data.isOk) {
              if (res.data.data.statusCode == 200) {
                that.$message.success("操作成功!");
                this.$set(this.tableData[this.form.index], 'wwSj', 0);
                this.$set(this.searchData[this.form.index], 'wwSj', 0);
              } else {
                this.$message.error(res.data.data.message)
              }
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(err => {
            this.dialogDiscount = false;
            this.telDisabled = false;
          })
      }
    },

    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },
    //导出方法
    //导出查询页 默认全部查询
    exportExcel() {
      const that = this;
      require.ensure([], async () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "药品名称",
          "产地名称",
          "库区",
          "规格",
          "批号",
          "单位",
          "单价",
          "零/整",
          "包装",
          "数量",
          "有效期",
          "入账日期",
          "打折情况",
          "返利情况",
          "是否拆零",
          "中包装",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "drugName",
          "productFactory",
          "storeNo",
          "spec",
          "batchNum",
          "unit",
          "price",
          "isRetail",
          "pack",
          "storeNum",
          "dueDate",
          "inAccountDate",
          "disCountRate",
          "isPromotion",
          "saleMPack",
          "mPack",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        await that.getExcelData();
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
      });
    },
    //导出当前页
    exportExcel1() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "药品名称",
          "产地名称",
          "库区",
          "规格",
          "批号",
          "单位",
          "单价",
          "零/整",
          "包装",
          "数量",
          "有效期",
          "入账日期",
          "打折情况",
          "返利情况",
          "是否拆零",
          "中包装",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "drugName",
          "productFactory",
          "storeNo",
          "spec",
          "batchNum",
          "unit",
          "price",
          "isRetail",
          "pack",
          "storeNum",
          "dueDate",
          "inAccountDate",
          "disCountRate",
          "isPromotion",
          "saleMPack",
          "mPack",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        if (this.searchData.length > 0) {
          const list = this.searchData; //把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
        } else {
          const list = this.tableData; //把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
        }
      });
    },
    // 折扣设置
    setDiscount(rows) {
      this.DiscountList = [];
      this.getDiscount();
      this.formDiscount = { ...this.initForm };
      this.formDiscount.storeID = rows.storeID;
      this.isPhones();
      this.isShow = true;
      this.dialogDiscount = true;
    },
    // 获取活动列表
    getDiscount() {
      this.$http
        .post("Dls/getFun", {
          action: "Getsalepromotionlist",
          obj: JSON.stringify({}),
        })
        .then((res) => {
          if (res.data.isok) {
            this.DiscountList = res.data.data.rows;
            this.isShow = false;
          }
        });
    },
    // 获取手机号码
    isPhones() {
      const that = this;
      that.$http.post("/Dls/GetPhone", {}).then((response) => {
        if (response.data.isOk) {
          that.phones = response.data.data.rows;
          // console.log(that.phones)
          // $("#myModal_jia").modal();
        } else {
          alert(response.data.message);
        }
      });
    },
    // 获取短信验证码
    getCode() {
      const that = this;
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!that.form.tel) {
        alert("输入的手机号码不能为空！");
      } else if (!reg.test(that.form.tel)) {
        alert("您输入的手机号码有错误！");
      } else {
        that.getsendMessage();
      }
    },
    // 按钮倒计时
    getsendMessage: async function () {
      //按钮120秒倒计时
      await this.sendMessage(); //120秒倒计时过后才能调用事件
      if (this.success) {
        this.totalCount = 120;
        this.disabled = true;
        let interval = setInterval(() => {
          this.totalCount--;
          if (this.totalCount === 0) {
            clearInterval(interval);
            this.disabled = false;
          }
        }, 1000);
      }
    },
    // 发送短信
    sendMessage: async function () {
      const that = this;
      await that.$http
        .post("/Dls/addaccount", { phone: that.form.tel })
        .then((response) => {
          //  console.log(response)
          if (response.data.isOk) {
            that.success = true;
            // alert("信息已发送，请注意查收")
            that.$message.success("信息已发送，请注意查收!");
          } else if (!response.data.isOk) {
            if (response.data.errorMessage == -3) {
              alert("发送一次短信可以使用1天，1天内不需要发送新短信");
            } else if (response.data.errorMessage == -4) {
              alert("短信发送失败，请联系管理员！");
            }
          }
        });
    },
    // 提交设置折扣请求
    submitUp() {
      if (this.formDiscount.promotionID == 0) {
        this.$message.warning("请选择活动主题！");
      } else if (
        this.formDiscount.disCount <= 0 ||
        this.formDiscount.disCount >= 1
      ) {
        this.$message.warning("折扣必须是0-1的数字!");
      } else if (this.formDiscount.phone == "") {
        this.$message.warning("您还没有选择手机号！");
      } else if (this.formDiscount.yzm == "") {
        this.$message.warning("验证码不能为空，请先获取验证码！");
      } else {
        this.$http.post("Dls/Createzhekou", this.formDiscount).then((res) => {
          if (res.data.data.isSucceed) {
            this.$message.success(res.data.data.msg);
            this.dialogDiscount = false;
            this.Search();
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
      }
    },
    cancelDiscount(rows) {
      this.$confirm("此操作将会取消您所设置的折扣, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("Dls/getFun", {
              action: "Cancelzhekou",
              obj: JSON.stringify({
                storeID: rows.storeID,
                promotionID: rows.promotionID,
              }),
            })
            .then((res) => {
              if (res.data.data.isSucceed) {
                this.$message.success(res.data.data.msg);
                this.Search();
              } else {
                this.$message.error(res.data.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //验证
    //  ypmc:function(){
    //       let reg1=/^[\u4e00-\u9fa5]{0,}$/;
    //        if(reg1.test(this.searchForm.ypmc)){
    //             //  this.Search()
    //        }
    //   },
    //   ph:function(){
    //        let reg2=/^[0-9]*$/;
    //        if(!reg2.test(this.searchForm.ph)){
    //             // this.Search()
    //        }
    //   },
    //   cdmc:function(){
    //         let reg3=/^[\u4e00-\u9fa5]{0,}$/;
    //         if(!reg3.test(this.searchForm.cdmc)){
    //             //  this.Search()
    //        }

    //   },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc = this.searchData[index].drugName;
      } else {
        this.searchForm.ypmc = this.tableData[index].drugName;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].productFactory;
      } else {
        this.searchForm.cdmc = this.tableData[index].productFactory;
      }
    },
    getClerkStoreGoodsQuery: async function (PageIndex) {
      this.PageNo = PageIndex || this.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkStoreGoodsQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          SearchType: this.SearchType,
        }),
      });
      if (res.isok) {
        const obj = res.data;
        this.tableData = obj.rows;
        this.total = obj.record;
        this.Pcount = obj.pcount;
        this.Record = obj.record;
        this.totalPurchMoney = obj.totalPurchMoney;
      }
    },
    getExcelData: async function () {
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkStoreGoodsQuery",
        obj: JSON.stringify({
          PageIndex: 1,
          PageSize: 50000,
          SearchType: this.SearchType,
          DrugName: this.searchForm.ypmc.trim(),
          BatchNum: this.searchForm.ph.trim(),
          ProductFactory: this.searchForm.cdmc.trim(),
          Spec: this.searchForm.gg.trim(),
        }),
      });
      if (res.isok) {
        const obj = res.data;
        this.excelData = obj.rows;
      }
    },
    //搜索
    Search: async function (PageIndex) {
      const that = this;
      // search 是 v-model="search" 的 search
      that.isLoading = true;
      //这里加表单验证，这块就不用我说了吧
      //假设表单验证通过，这时候就可以ajax提交表单
      if (!PageIndex) {
        PageIndex = 1;
      }
      that.PageNo = PageIndex || that.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkStoreGoodsQuery",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          SearchType: this.SearchType,
          DrugName: that.searchForm.ypmc.trim(),
          BatchNum: that.searchForm.ph.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          Spec: that.searchForm.gg.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        if (that.Pcount === 0) {
          that.tableData = obj.rows;
        } else {
          that.searchData = obj.rows;
        }
        that.total = obj.record;
        that.Pcount = obj.pcount;
        that.Record = obj.record;
        that.isLoading = false;
        if (obj.pcount == 0) {
          alert("没有符合条件的信息");
          that.getClerkStoreGoodsQuery();
        }
      }
    },

    pagechange: function (currentPage) {
      if (this.searchData.length > 0) {
        this.Search(currentPage);
      } else {
        this.getClerkStoreGoodsQuery(currentPage);
      }
    },
    //搜索功能
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getClerkStoreGoodsQuery();
    this.initForm = { ...this.formDiscount };
  },
};
</script>
<style scoped>
.table-hover>tbody>tr:hover {
  background-color: #dee2e6 !important;
}

.font {
  font-size: 15px;
}

.font_yz {
  font-size: 1px;
  color: red;
}

.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}

.heit {
  height: 1.5rem;
}

.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}

.jz_middle {
  vertical-align: middle;
}

.head-style {
  display: block;
  width: 100%;
  height: 50px;
  background: #3190e8;
}
</style>



// WEBPACK FOOTER //
// src/pages/stock.vue